import { createFileRoute } from "@tanstack/react-router";
import AdminBillingPlansPage from "@/admin/pages/billing-plans";

export const Route = createFileRoute("/admin/billing-plans")({
  component: AdminBillingPlansPage,
});
